import { render, staticRenderFns } from "./baseLayout.vue?vue&type=template&id=78ad1a3e"
import script from "./baseLayout.vue?vue&type=script&lang=js"
export * from "./baseLayout.vue?vue&type=script&lang=js"
import style0 from "./baseLayout.vue?vue&type=style&index=0&id=78ad1a3e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78ad1a3e')) {
      api.createRecord('78ad1a3e', component.options)
    } else {
      api.reload('78ad1a3e', component.options)
    }
    module.hot.accept("./baseLayout.vue?vue&type=template&id=78ad1a3e", function () {
      api.rerender('78ad1a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Wrappers/baseLayout.vue"
export default component.exports